export interface NativePlatform {
  publicUrl(value: string): string;
  shareFile(blob: Blob, filename: string): Promise<boolean>;
}

declare global {
  interface Window {
    drawOnAMapNative?: NativePlatform;
    nativeAppReady?: Promise<void>;
  }
}

export function publicAppUrl(value: string): string {
  return window.drawOnAMapNative?.publicUrl(value) ?? value;
}

export async function downloadFile(blob: Blob, filename: string): Promise<boolean> {
  if (window.drawOnAMapNative) return window.drawOnAMapNative.shareFile(blob, filename);
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  // A generated download is not an outside click on the user's open controls.
  link.addEventListener('click', event => event.stopPropagation());
  document.body.appendChild(link);
  link.click();
  setTimeout(() => { link.remove(); URL.revokeObjectURL(url); }, 500);
  return true;
}
